import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import packageJson from '../package.json'

 
const app = createApp(App)

app.provide('wdm', { 
    'version' : packageJson.version,
    'system': ''
})

 
//createApp(App).use(router).mount('#app')
app.use(router)
app.mount('#app')